export default __webpack_public_path__ + "static/media/sale5.c00662ab.webp";